import { useEffect, useState } from "react";
import { Music, VolumeX, Volume2 } from "lucide-react";
import { startMusic, stopMusic, setVolume, getVolume } from "@/lib/music";

const KEY = "vexis_music";

export default function MusicToggle() {
  const [on, setOn] = useState(false);
  const [vol, setVol] = useState(0.18);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (saved) {
      try {
        const s = JSON.parse(saved);
        if (typeof s.vol === "number") { setVol(s.vol); setVolume(s.vol); }
        if (s.on) tryStart(true);
      } catch { /* ignore */ }
    }
    // eslint-disable-next-line
  }, []);

  const persist = (nextOn, nextVol) => {
    localStorage.setItem(KEY, JSON.stringify({ on: nextOn, vol: nextVol }));
  };

  const tryStart = async (silent = false) => {
    const ok = await startMusic();
    if (ok) { setOn(true); persist(true, vol); }
    else if (!silent) { /* no audio ctx */ }
  };

  const toggle = async () => {
    if (on) { stopMusic(); setOn(false); persist(false, vol); }
    else { await tryStart(); }
  };

  const change = (v) => {
    setVol(v); setVolume(v); persist(on, v);
  };

  return (
    <div className="relative flex items-center" data-testid="music-toggle">
      <button onClick={toggle} className="btn-ghost !p-2" aria-label={on ? "Pause music" : "Play music"} data-testid={on ? "music-on" : "music-off"}>
        {on ? <Music className="w-4 h-4 text-[color:var(--gold)]" /> : <VolumeX className="w-4 h-4 text-slate-400" />}
      </button>
      {on && (
        <>
          <button onClick={() => setExpanded((e) => !e)} className="ml-1 text-slate-500 hover:text-white text-xs hidden sm:inline" data-testid="music-vol-expand">
            <Volume2 className="w-3.5 h-3.5" />
          </button>
          {expanded && (
            <div className="absolute right-0 top-full mt-1 vexis-card p-3 w-40 z-50" data-testid="music-vol-panel">
              <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-1">Volume</div>
              <input type="range" min="0" max="0.5" step="0.01" value={vol} onChange={(e) => change(parseFloat(e.target.value))}
                className="w-full accent-[color:var(--gold)]" data-testid="music-vol-slider" />
            </div>
          )}
        </>
      )}
    </div>
  );
}
